import instance_api from "../../config/axiosConfig";
import {getOtSkills, getOvertimeCallsheet, addOTShiftAPI, duplicateCheckOTShift, resolveOTWbFailed, callLogAPI, otSignupsAPI, getVotReport, addOTShiftStatus, getSessionStatus as getSessionStatusUrl, getVotReportDetail, getVotCallsheet } from "../../constants/constants";

class OvertimeAPI {
    
    constructor(name) {
        this.name = name;
    }

    getOTSkillsData(station='') {
        return instance_api("GET", getOtSkills(station));
    }
    
    getCallsheet({ empId ='', otGroup='', schedBidGroup='', volOtDate='', station='', shiftsReqs=[], sessionToken='', department='', isCurrentCompleted=false }) {
        const data = {
            empId,
            otGroup,
            schedBidGroup,
            volOtDate,
            station,
            shiftsReqs,
            sessionToken,
            department,
            isCurrentCompleted
        };

        return instance_api('POST', getOvertimeCallsheet(), data);
    }

    getSessionStatus({ schedBidGroup = '', otGroup = '', volOtDate = '', station = '', department = '' }) {
        const data = {
            schedBidGroup,
            otGroup,
            volOtDate,
            station,
            department,
        };

        return instance_api('POST', getSessionStatusUrl(), data);
    }

    addOTShift(data) {
        return instance_api('POST', addOTShiftAPI(), data);
    }

    checkDuplicateShift(data) {
        return instance_api('POST', duplicateCheckOTShift(), data);
    }

    resolveWbFailed(data) {
        return instance_api('POST', resolveOTWbFailed(), data);
    }

    getVotReport({ station = '', department = '', startDate = '', endDate = '' }) {
        return instance_api('GET', getVotReport(station, department, startDate, endDate));
    }

    getVotReportDetail(params) {
        return instance_api('GET', getVotReportDetail(params));
    }

    getVotCallsheet(votId) {
        return instance_api('GET', getVotCallsheet(votId));
    }

    postCallLog({ callType='', isAnswered=false, isCallReturned=false, action='', createdBy='', callNotes='', empId='', votRequestId='', shiftType='', startTime='', endTime='', workLocation='', wbFailureResolveAction='', wbFailureResolveComments='', station='', lastUpdated='', department='', sessionToken=''}) {
        const data={
            callType,
            isAnswered,
            isCallReturned,
            action,
            createdBy,
            callNotes,
            empId,
            votRequestId,
            shiftType,
            startTime,
            endTime,
            workLocation,
            wbFailureResolveAction,
            wbFailureResolveComments,
            station,
            lastUpdated,
            department,
            sessionToken
        }
        return instance_api('POST', callLogAPI(), data);
    }

    getCallLog({ votId, empId, department = '' }) {
        const url = `${callLogAPI()}?votRequestId=${encodeURIComponent(votId)}&empId=${encodeURIComponent(empId)}&department=${encodeURIComponent(department)}`;
        return instance_api('GET', url);
    }

    checkOTShiftStatus(reqIds) {
        return instance_api('GET', `${addOTShiftStatus()}?reqIds=${reqIds}`);
    }

    getOtSignups({
        empId = '',
        station = '',
        otGroup = '',
        schedBidGroup = '',
        volOtDate = '',
        sessionToken = '',
        otDayShifts = [],
        otShiftSignUps = [],
    }) {
        const data = {
            empId,
            station,
            otGroup,
            schedBidGroup,
            volOtDate,
            sessionToken,
            otDayShifts,
            otShiftSignUps,
        };
        return instance_api('POST', otSignupsAPI(), data);
    }
}

export const {
    getOTSkillsData,
    getCallsheet,
    getSessionStatus: getSessionStatusData,
    addOTShift,
    checkDuplicateShift,
    resolveWbFailed,
    getVotReport: getVotReportData,
    getVotReportDetail: getVotReportDetailData,
    getVotCallsheet: getVotCallsheetData,
    postCallLog,
    getCallLog,
    checkOTShiftStatus,
    getOtSignups
} = new OvertimeAPI("instance");
